/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AttendanceTypeEnum,
  AttendanceTypeEnumOptional,
  AttendanceTypeEnumMetaI,
  AttendanceTypeEnumTrackedI,
} from "./attendance-type-enum";
import {
  AttendanceTypeEnumTracked,
  AttendanceTypeEnumMeta,
} from "./attendance-type-enum";

/**
 *
 * @export
 * @interface UnifiedClassAttendanceBase
 */
export interface UnifiedClassAttendanceBaseOptional {
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceBase
   */
  attend?: AttendanceTypeEnum;
}

export interface UnifiedClassAttendanceBase extends UnifiedClassAttendanceBaseOptional {
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceBase
   */
  attend?: AttendanceTypeEnum;
}

export interface UnifiedClassAttendanceBaseTrackedI {
  /**
   *
   * @type {AttendanceTypeEnum}
   * @memberof UnifiedClassAttendanceBase
   */
  attend?: AttendanceTypeEnum;
  attendIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassAttendanceBase",
  function (model: UnifiedClassAttendanceBase) {},
);

export type UnifiedClassAttendanceBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  attend: PropertyMeta<AttendanceTypeEnumMetaI>;
}>;

export var UnifiedClassAttendanceBaseMeta: UnifiedClassAttendanceBaseMetaI =
  {} as UnifiedClassAttendanceBaseMetaI;
UnifiedClassAttendanceBaseMeta = typeMeta("UnifiedClassAttendanceBase", {
  attend: propertyMeta("attend", false, false, false, AttendanceTypeEnumMeta),
});

const metaI = UnifiedClassAttendanceBaseMeta;

registerMeta(() => {});

export class UnifiedClassAttendanceBaseTracked implements UnifiedClassAttendanceBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  attend__I?: AttendanceTypeEnum = undefined;
  attendIsSet: boolean = false;
  set attend(v: undefined | AttendanceTypeEnum) {
    if (v !== undefined) {
      this.attend__I = v;
      this.attendIsSet = true;
    } else {
      this.attend__I = v || undefined;
      this.attendIsSet = false;
    }
    this.changeTracker = true;
  }
  get attend() {
    return this.attend__I;
  }
  constructor(
    config?: UnifiedClassAttendanceBaseOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: UnifiedClassAttendanceBaseOptional,
    options?: AssignOptions,
  ): UnifiedClassAttendanceBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.attend && this.attendApplyFilter(optionsRequired.filter)) {
      this.attend = config.attend;
      if (optionsRequired.unassign) this.attendIsSet = false;
      else this.attendIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassAttendanceBaseTrackedI {
    const cloned = {} as UnifiedClassAttendanceBaseTrackedI;
    if (
      this.attendIsSetDeep() &&
      this.attendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.attendIsSet = true;
      cloned.attend = this.attend;
    } else {
      //cloned.attendIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassAttendanceBaseTrackedI {
    if (!this.attendApplyFilter(filter)) this.attendIsSet = false;

    return this;
  }
  attendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassAttendanceBaseMeta.attend,
      UnifiedClassAttendanceBaseMeta,
      this.attend,
      this,
    );
  }
  attendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.attendIsSet && this.attendApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.attendIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
